import { requestErrorMiddleware } from '@app/sentry/requestErrorMiddleware';
import { configureStore } from '@reduxjs/toolkit';

import { baseApi } from './index.api';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware, requestErrorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
